module.exports = __webpack_public_path__ + "static/media/Moneycorp.1d8e289b.png";